import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import { Router, Route } from 'react-router-dom';
import { history } from './Routes/history';

import { theme } from './Configs/Theme';

import Header from './Views/Layout/Header/Header';
import Footer from './Views/Layout/Footer/Footer';
import Maintenance from './Views/Maintenance/Maintenance';
import { CircularMenuProvider } from './Contexts/CircularMenuContext';

function MaintenanceApp({ message }) {
  const classes = useStyles();

  useEffect(() => {
    return history.listen(() => window.location.reload(true));
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <CircularMenuProvider>
        <Router history={history}>
          <Route
            path="/"
            component={() => {
              return (
                <div className={classes.container}>
                  <Header maintenanceMode />
                  <div className={classes.appContainer}>
                    <Maintenance message={message} />
                  </div>
                  <Footer />
                </div>
              );
            }}
          />
        </Router>
      </CircularMenuProvider>
    </MuiThemeProvider>
  );
}

const useStyles = makeStyles({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  }
});

export default MaintenanceApp;
